import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,

	Box,
	Grid,
	Button,
	TextField,
	Typography
} from "@mui/material";
import {
	withStyles
} from "@mui/styles";
import {
	FileItemCard
} from "../../../../applications/Application/components/DialogCarAcceptance";

class DialogInformation extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			item: null,
			isOpen: false
		};
	}

	open = ({ item }) => {
		this.setState({
			item,
			isOpen: true,
		})
	}
	close = () => {
		this.setState({
			item: null,
			isOpen: false
		})
	}

	render () {
		const {
			classes
		} = this.props;
		const files = [];

		return (
			<Dialog
				fullWidth
				open={false}
				maxWidth="sm"
				classes={{root: classes.dialog}}
			>
				<DialogTitle>
					<Typography variant="h3">Детализация приемки авто</Typography>
				</DialogTitle>
				<DialogContent>
					<Box pt={1}/>
					<Box className={classes.section}>
						<Typography className={classes.sectionTitle}>Фото / видео фиксация</Typography>
						<Grid container spacing={1}>
							{(files || []).map((file, index) => (
								<Grid item xs={4}>
									<FileItemCard
										key={`FileItemCard-${ file.lastModified }`}
										item={file}
										disabledEdit
										onRemove={this.removeFile.bind(this, index)}
									/>
								</Grid>
							))}
						</Grid>
					</Box>
					<Box mt={2}/>
					<Box className={classes.section}>
						<Typography className={classes.sectionTitle}>Описание</Typography>
						<Box
							className={classes.sectionMessage}
							dangerouslySetInnerHTML={{
								__html: "Тут что то будет написано.\nТут что то будет написано.\nТут что то будет написано.\nТут что то будет написано.\nТут что то будет написано.\nТут что то будет написано.\nТут что то будет написано."
							}}
						/>
					</Box>
				</DialogContent>
				<DialogActions>
					<Box px={2} display="flex" justifyContent="flex-end">
						<Button
							variant="outlined"
						>Отменить</Button>
					</Box>
				</DialogActions>
			</Dialog>
		)
	}
}

const styles = {
	dialog: {
		"& .MuiDialogTitle-root": {
			background: "#FF3F3F",
		},
		"& .MuiDialogTitle-root .MuiTypography-h3": {
			color: "white",
			textAlign: "left",
		},
	},

	section: {},
	sectionTitle: {
		marginBottom: 8,
		fontSize: 18,
		lineHeight: 1.2,
		fontWeight: "600",
	},
	sectionMessage: {
		padding: "8px",
		boxSizing: "border-box",
		borderRadius: "4px",
		border: "1px solid #00000026",
		fontSize: "16px",
		lineHeight: "1.2",
		color: "#000000c7",
		background: "#00000003",
	},
};
DialogInformation = withStyles(styles)(DialogInformation);

export default DialogInformation
